import { useSearchParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle, Mail, ArrowRight, ArrowLeft, AlertCircle } from 'lucide-react';

export default function MeetKGOBThankYou() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';
  const name = searchParams.get('name') || '';

  return (
    <div className="min-h-screen bg-[#F7F6F2]">
      <Helmet>
        <title>Success - Your Guide is On the Way | KGOB</title>
        <meta name="description" content="Success! Your guide is on the way from KGOB CPAs & Advisors." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      
      <Header />
      
      <main className="py-16 md:py-24">
        <div className="container mx-auto px-6">
          <div className="max-w-2xl mx-auto">
            <Card className="border-2 border-[#D4AF37] shadow-xl">
              <CardContent className="p-8 md:p-12 text-center">
                {/* Success Icon */}
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <CheckCircle className="w-10 h-10 text-green-600" />
                </div>
                
                <h1 className="font-['Playfair_Display'] text-3xl md:text-4xl text-[#0B2240] mb-4">
                  Success — your 1-page guide is on the way ✅
                </h1>
                
                <p className="text-lg text-[#4C5A70] mb-6">
                  We just emailed your PDF: <strong>"Holiday Money-Saver Kit"</strong> to {email ? <span className="text-[#0B2240] font-medium">{email}</span> : 'the address you entered'}.
                </p>
                
                {/* Delivery Note */}
                <div className="bg-[#FEF9E7] border-2 border-[#D4AF37]/30 rounded-lg p-6 mb-8">
                  <div className="flex items-start gap-3 text-left">
                    <Mail className="w-6 h-6 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                    <div>
                      <p className="font-semibold text-[#0B2240] mb-1">
                        Look for an email from: noreply@kgob.com
                      </p>
                      <p className="text-sm text-[#4C5A70]">
                        If you don't see it within a few minutes, check Spam / Promotions.
                      </p>
                    </div>
                  </div>
                </div>
                
                {/* Support Line */}
                <div className="flex items-center justify-center gap-2 text-[#4C5A70] mb-8">
                  <AlertCircle className="w-4 h-4" />
                  <p className="text-sm">
                    Need help? Email <a data-testid="meet-k-g-o-b-thank-you-a-1" href="mailto:support@kgob.com" className="text-[#D4AF37] hover:underline font-medium">support@kgob.com</a> and we'll resend it.
                  </p>
                </div>
                
                {/* Primary CTA */}
                <a 
                  href="https://letstalktaxes.io" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-gradient-to-r from-[#D4AF37] to-[#B99610] text-[#0B2240] font-semibold px-8 py-4 rounded-lg hover:opacity-90 transition-all mb-4 w-full justify-center"
                  data-testid="view-bundle-cta"
                >
                  View the Let's Talk Taxes Holiday Bundle
                  <ArrowRight className="w-5 h-5" />
                </a>
                
                {/* Secondary Link */}
                <Link data-testid="meet-k-g-o-b-thank-you-link-1" 
                  to="/our-story"
                  className="inline-flex items-center gap-2 text-[#0B2240] hover:text-[#D4AF37] transition-colors font-medium"
                >
                  <ArrowLeft className="w-4 h-4" />
                  Meet KGOB
                </Link>
                
                {/* Footer Note */}
                <p className="text-xs text-gray-500 mt-8">
                  Unsubscribe anytime.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
